/* ===== VMS Storage — helper dùng chung để đặt thời gian cache, có TTL, cho nhiều tính năng ===== */
window.VmsStorage = (function () {
  function save(key, value, ttlMs) {
    try {
      localStorage.setItem(key, JSON.stringify({
        value: value,
        expiry: Date.now() + ttlMs
      }));
    } catch (e) {}
  }

  function get(key) {
    try {
      var raw = localStorage.getItem(key);
      if (!raw) return null;

      var data = JSON.parse(raw);
      if (!data || data.value === undefined || !data.expiry) return null;

      if (Date.now() > data.expiry) {
        localStorage.removeItem(key);
        return null;
      }

      return data.value;
    } catch (e) {
      return null;
    }
  }

  function remove(key) {
    try { localStorage.removeItem(key); } catch (e) {}
  }

  return { save: save, get: get, remove: remove };
})();